import { openingHoursBuilder } from '../../..';
var NewScheduleBuilder = /** @class */ (function () {
    function NewScheduleBuilder() {
        this.schedule = {
            openingHours: openingHoursBuilder(),
            downTimes: [],
            timeZone: 'UTC',
        };
    }
    NewScheduleBuilder.prototype.businessHours = function (openingHours) {
        this.schedule.openingHours = openingHours;
        return this;
    };
    NewScheduleBuilder.prototype.withDailyActivities = function (day, data) {
        this.schedule.openingHours.openingHours[day] = data;
    };
    NewScheduleBuilder.prototype.withDownTimes = function (downTimes) {
        this.schedule.downTimes = downTimes;
        return this;
    };
    NewScheduleBuilder.prototype.withTimeZone = function (timeZone) {
        this.schedule.timeZone = timeZone;
        return this;
    };
    NewScheduleBuilder.prototype.build = function () {
        return this.schedule;
    };
    return NewScheduleBuilder;
}());
export { NewScheduleBuilder };
//# sourceMappingURL=new-schedule.builder.js.map